import { inject, PLATFORM_ID } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ProviderService } from '../Services/provider.service';

export const ibanResolverResolver: ResolveFn<any> = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const _ProviderService = inject(ProviderService);
  const id = route.paramMap.get('id');
  try{
    let e  = _ProviderService.getIban(id!);
    return e;
  }catch(e){
    router.navigate(['/']);
    return false;
  }
};
